interface BottomMessageProps{
    visible: boolean,
    groupName?: string,
    hideButton?: boolean
}

const BottomMessage = ({ visible, groupName, hideButton }:BottomMessageProps) => {
  if (visible) {
    return (
      <div
        className="bg-[rgba(95,72,138,0.75)] w-[92%] bottom-0 m-[4%] px-[4%] py-[2%] rounded-[4%]"
        style={{ position: hideButton ? undefined : 'absolute' }}
      >
        <div className="flex flex-row items-center justify-around">
          <span
            className="text-white text-base font-bold flex-1"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            {groupName || 'Group A'}
          </span>
          {!hideButton && (
            <div className="flex flex-row items-center">
              <span
                className="text-white text-base font-bold"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                Click to start Presentation &gt;
              </span>
              <button
                className="bg-[#B0E025] py-[0.6%] px-[6%] border border-[#E04725] rounded-[6%] ml-[2%]"
                onClick={() => {}}
              >
                <img
                  src="/assets/startPresentation.png"
                  alt="Start Presentation"
                  className="h-[6%] w-[6%] object-contain"
                />
              </button>
            </div>
          )}
          <button
            className="ml-[4%]"
            onClick={() => {}}
          >
            <img
              src="/assets/whiteDots.png"
              alt="Menu"
              className="h-[6%] w-[6%] object-contain"
            />
          </button>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default BottomMessage;